import ShareOTPLoginPage from './ShareOTPLoginPage';

export default ShareOTPLoginPage;
